import React, { useCallback } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { getOrganizationInitials } from '@/lib/utils'
import { useAuthStore } from '@/store/auth'
import { useNavigate } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'

const UserNav: React.FC = () => {
  const user = useAuthStore(state => state.user)
  const logout = useAuthStore(state => state.clearAuthData)
  const navigate = useNavigate()
  const posthog = usePostHog()

  const handleLogout = useCallback(async () => {
    posthog?.capture('logout_clicked', { location: 'user_nav' });
    logout();
    setTimeout(() => navigate('/sign-in', { replace: true }), 0);
  }, [logout, navigate, posthog]);

  const userName = user?.email

  if (user) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant='ghost' className='relative h-8 w-8 rounded-full'>
            <Avatar className='h-8 w-8'>
              <AvatarImage
                /* src={user.organisation.logo ?? ''}
                alt={user.organisation.name ?? ''} */
              />
              <AvatarFallback className='border'>
                {getOrganizationInitials(
                  typeof userName === 'string' ? userName : ''
                )}
              </AvatarFallback>
            </Avatar>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className='w-56' align='end' forceMount>
          <DropdownMenuLabel className='font-normal'>
            <div className='flex flex-col space-y-1'>
              <p className='text-sm font-medium leading-none'>
                {/* {user.name} */}
              </p>
              <p className='text-xs leading-none text-muted-foreground'>
                {user.email}
              </p>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleLogout}>
            Log out
            <DropdownMenuShortcut>⇧⌘Q</DropdownMenuShortcut>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }

  return null
}

export { UserNav }